import React from 'react';
import Hero from '../components/Hero/Hero';
import NFSeSpotlight from '../components/NFSeSpotlight/NFSeSpotlight';
import Features from '../components/Features/Features';
import CallToAction from '../components/CallToAction/CallToAction';
import Services from '../components/Services/Services';
import usePageMeta from '../hooks/usePageMeta';

const Home: React.FC = () => {
  usePageMeta({
    title: 'UpdateCommit — Integração, Automação e Desenvolvimento de Software',
    description:
      'UpdateCommit — especialistas em integração de sistemas, automação de processos e desenvolvimento de software personalizado. Conectamos suas plataformas e automatizamos seus fluxos.',
    path: '/',
  });

  return (
    <div>
      <Hero />
      <NFSeSpotlight />
      <Features />
      <Services />
      <CallToAction />
    </div>
  );
};

export default Home;
